/**
 * Qui peut être PROPOSÉ comme participant — règle unique, pure, lue par le serveur ET l'écran.
 *
 * Décision 3.6 de Valérie (PR #7) : le RH et le GES ne s'entraînent pas. Ils ne sont donc plus
 * proposés dans les sélecteurs de participants (challenges, puis campagnes et parcours), et le
 * serveur refuse de les ajouter. Ceux qui sont DÉJÀ inscrits restent inscrits (décision 1 du
 * 30/09/2026) : cette règle ne vaut que pour les propositions, jamais pour les inscriptions
 * existantes.
 *
 * Ne rien ajouter d'autre dans ce fichier : il est partagé entre plusieurs chantiers.
 */
export const NON_TRAINEE_PROFILES = ["GES", "RH"] as const;

export function canBeProposedAsParticipant(profileType?: string | null): boolean {
  if (!profileType) return true;
  return !(NON_TRAINEE_PROFILES as readonly string[]).includes(profileType);
}
